export { default as PendingSkills } from './sections/PendingSkills';
export { default as SolvedSkills } from './sections/SolvedSkills';
